<template>
  <div>
      <video autoplay muted loop class="hover_video" src="@/assets/video/kikorun.mp4"></video>
      <p class="description pd-top-40">
        Kiko Run adalah game endless run yang berlatarbelakang dunia bawah air yang ditinggali Kiko bersama teman-temannya dan bertujuan untuk mengalahkan Krabbot. Kiko Run diadaptasi dari serial animasi MNC Animasi “Kiko” yang tayang setiap hari Minggu pukul 09.00 WIB.
      </p>
  </div>
</template>

<script>
export default {
  name: 'KikoRun',
  data () {
    return {

    }
  }
}
</script>
